<template>
  <div :class="classNames">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    noDecoration: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classNames() {
      let classNames = "title-widget text-h5 font-weight-bold";

      if (this.noDecoration) classNames += " title-widget-no-decoration";

      return classNames;
    },
  },
};
</script>

<style>
.title-widget:not(.title-widget-no-decoration)::after {
  content: "";
  display: block;
  background: var(--v-primary-base);
  border-radius: 3px;
  height: 3px;
  margin-top: 4px;
}
</style>
